import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import AddressControl from "../../form/AddressControl";

class shippingorderForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-sm-2 col-sm-push-10">
                        <TextInput {...this.props.getFieldProps(this.props.componentConfig.idfield)} name={this.props.componentConfig.idfield} value={ this.props.values[this.props.componentConfig.idfield] } label="Kód" role="idfield"/>
                    </div>
                    <div className="col-sm-10 col-sm-pull-2">
                        <TextInput {...this.props.getFieldProps("tracking_id")} disabled={"disabled"} name="tracking_id" value={ this.props.values.tracking_id } label="Követési kód"/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select
                            disabled={"disabled"}
                            label="Partner"
                            name="partner"
                            component="partner"
                            objectValue={true}
                            labelKey="name"
                            valueKey="partner_id"
                            storeType="remote"
                            {...this.props.getFieldProps("partner")}
                            value={ this.props.values.partner }
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <label>Honnan</label>
                        <TextInput {...this.props.getFieldProps("origin")} disabled={"disabled"} name="origin" value={ this.props.values.origin } label={false}/>
                        <div className="row form-row">
                            <AddressControl disabled={"disabled"} name="origin_address" value={ this.props.values.origin_address } label="Honnan" saveChanges={ this.props.setFieldValue }/>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <label>Hova</label>
                        <TextInput {...this.props.getFieldProps("destination")} disabled={"disabled"} name="destination" value={ this.props.values.destination } label={false}/>
                        <div className="row form-row">
                            <AddressControl disabled={"disabled"} name="destination_address" value={ this.props.values.destination_address } label="Hova" saveChanges={ this.props.setFieldValue }/>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(shippingorderForm);
